<template>
  <div class="modal inmodal" ref="modalDialog" tabindex="-1" role="dialog" aria-hidden="true">
    <div :class="['modal-dialog', sizeClass]">
      <div class="modal-content">
        <div class="modal-header" v-if="showHeader">
          <button type="button" class="close" data-dismiss="modal" v-if="showCloseHeader">
            <span aria-hidden="true">
              <i class="far fa-times"></i>
            </span>
            <span class="sr-only">Close</span>
          </button>

          <h4 class="modal-title">
            <i v-if="icon" :class="['far', icon]"></i>
            {{title}}
          </h4>
        </div>
        <div
          :class="['modal-body', scrollable ? 'modal-scrollable' : '', !showFooter ? 'modal-body-nofooter' : '']"
          ref="modalContentBody"
          :style="{'overflow-y': scrollable ? 'auto' : 'visible'}">
          <div v-if="autoCloseTimerEnabled" class="modal-dialog-close-timer">
            <div class="progress" :style="closeTimerProgressBarStyle" />
          </div>
          <slot />
        </div>
        <div class="modal-footer" v-if="showFooter">
          <div class="modal-footer-buttons modal-footer-left" v-if="showDelete">
            <FormButton
              class="btn-danger float-left"
              ref="submitButton"
              v-if="showDelete"
              :loading="deleting"
              @click="onDelete"
            >{{deleteTitle}}</FormButton>
          </div>
          <div class="modal-footer-buttons modal-footer-right">
            <slot name="rightFooterButtons" />
            <button type="button" class="btn btn-default" data-dismiss="modal" v-if="showClose">{{closeTitle}}</button>
            <FormButton
              class="btn-primary"
              ref="submitButton"
              v-if="showSubmit"
              :loading="submitting"
              @click="onSubmitForm"
              :disabled="submitDisabled"
            >{{submitTitle}}</FormButton>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.inmodal .modal-header {
  padding: 10px 15px 10px 15px;
}
.modal-dialog {
  margin-top: 3rem;
}
.modal-title > i {
  font-size: 32px;
  margin-right: 4px;
}
.modal-title {
  text-align: left;
  font-weight: 200;
}
.modal-body {
  padding: 15px 25px 25px 25px;
  max-height: 70vh;
}
.modal-body .scrollable {
  overflow-y: auto;
}
.modal-footer {
  -ms-flex-align: stretch;
  align-items: stretch;
}
.modal-footer-left {
  flex: 1;
  justify-content: left;
}
.modal-footer-right {
  flex: 1;
  text-align: right;
}
.modal-footer > .modal-footer-buttons > :not(:last-child) {
    margin-right: .25rem;
}
.modal-footer > .modal-footer-buttons > :not(:first-child) {
    margin-left: .25rem;
}
.modal-dialog-close-timer {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  height: 3px;
}
.modal-dialog-close-timer > .progress {
  position: absolute;
  left: 0;
  top: 0;
  height: 3px;
  background-color: $general-highlight-color;
  border-radius: 0;
}
</style>

<script>
export default {
  name: "ModalDialog",
  props: {
    title: String,
    icon: String,
    sizeClass: {
      type: String,
      default: "modal-lg",
    },
    showHeader: {
      type: Boolean,
      default: true
    },
    showFooter: {
      type: Boolean,
      default: true,
    },
    closeTitle: {
      type: String,
      default: 'Close'
    },
    showDelete: {
      type: Boolean,
      default: false
    },
    showCloseHeader: {
      type: Boolean,
      default: true
    },
    showClose: {
      type: Boolean,
      default: true
    },
    deleteTitle: {
      type: String,
      default: 'Delete'
    },
    showSubmit: {
      type: Boolean,
      default: true,
    },
    submitTitle: {
      type: String,
      default: "Save",
    },
    submitDisabled: {
      type: Boolean,
      default: false,
    },
    submitting: Boolean,
    deleting: Boolean,
    scrollable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      autoCloseTimerEnabled: false,
      autoCloseTimerDuration: 0,
      autoCloseTimerTime: 0,
      autoCloseTimerId: null
    }
  },
  computed: {
    closeTimerProgressBarStyle() {
      if(this.autoCloseTimerEnabled && this.autoCloseTimerDuration > 0) {
        return {
          width: (100 - Math.round((this.autoCloseTimerTime / this.autoCloseTimerDuration) * 100.0)) + '%'
        }
      }
      return {}
    }
  },
  mounted() {
    $(this.$refs.modalDialog).on("shown.bs.modal", () => {
      this.$emit("shown");
    });
    $(this.$refs.modalDialog).on("hidden.bs.modal", () => {
      this.$emit("closed");
    });
  },
  beforeDestroy() {
    $(this.$refs.modalDialog).off("shown.bs.modal");
    $(this.$refs.modalDialog).off("hidden.bs.modal");
  },
  methods: {
    onSubmitForm(evt) {
      this.$emit("submitted", evt);
    },
    onDelete(evt) {
      this.$emit('deleted', evt);
    },
    scrollToTop() {
      this.$refs.modalContentBody.scrollTo(0, 0);
    },
    scrollToBottom() {
      this.$refs.modalContentBody.scrollTop = this.$refs.modalContentBody.scrollHeight
    },
    scrollToElement(el) {
      if(el)
        this.$refs.modalContentBody.scrollTo(0, el.offsetTop)
    },
    startAutoCloseTimer(timeoutTimeMS) {
      this.autoCloseTimerEnabled = true
      this.autoCloseTimerDuration = timeoutTimeMS
      this.autoCloseTimerTime = 0

      var intervalTime = 50
      var dlg = this
      this.autoCloseTimerId = setInterval(() => {
        dlg.autoCloseTimerTime += intervalTime

        if(dlg.autoCloseTimerTime >= dlg.autoCloseTimerDuration && dlg.autoCloseTimerEnabled) {
          dlg.cancelAutoCloseTimer()
          $(dlg.$refs.modalDialog).modal('hide')
        }
      }, intervalTime)
    },
    cancelAutoCloseTimer() {
      this.autoCloseTimerEnabled = false
      if(this.autoCloseTimerId) {
        clearInterval(this.autoCloseTimerId)
      }
    }
  },
};
</script>